/**
 * Servicio para gestión de menús de restaurantes (Directo a Firestore)
 */

import { db } from './firebase';
import { collection, getDocs } from 'firebase/firestore';

export interface MenuCategory {
    categoryId: string;
    restaurantId: string;
    name: string;
    images: string[];
    status: 'activa' | 'inactiva';
    displayOrder: number;
    createdAt: {
        seconds: number;
        nanoseconds: number;
    };
    updatedAt: {
        seconds: number;
        nanoseconds: number;
    };
}

export interface MenuProduct {
    productId: string;
    restaurantId: string;
    categoryId: string;
    name: string;
    description?: string;
    price: number;
    images: string[];
    availability: 'disponible' | 'agotado';
    status: 'activo' | 'inactivo';
    createdAt: {
        seconds: number;
        nanoseconds: number;
    };
    updatedAt: {
        seconds: number;
        nanoseconds: number;
    };
}

export interface MenuResponse {
    success: boolean;
    restaurantId: string;
    categories: MenuCategory[];
    products: MenuProduct[];
}

/**
 * Obtener menú completo de un restaurante (Directo a Firestore)
 */
export async function getMenu(restaurantId: string): Promise<MenuResponse> {
    try {
        // En Firestore, el menú está en subcolecciones de /menus/{restaurantId}
        const categoriesRef = collection(db, 'menus', restaurantId, 'categories');
        const productsRef = collection(db, 'menus', restaurantId, 'products');

        const [categoriesSnap, productsSnap] = await Promise.all([
            getDocs(categoriesRef),
            getDocs(productsRef)
        ]);

        const categories = categoriesSnap.docs.map(doc => ({
            categoryId: doc.id,
            ...doc.data()
        })) as MenuCategory[];

        const products = productsSnap.docs.map(doc => ({
            productId: doc.id,
            ...doc.data()
        })) as MenuProduct[];

        return {
            success: true,
            restaurantId,
            categories,
            products
        };
    } catch (error) {
        console.error("Error getting menu from Firestore:", error);
        return {
            success: false,
            restaurantId,
            categories: [],
            products: []
        };
    }
}
